import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../constants'
import { apiGetCatchSummary } from './index'

export const useCatchSummary = (sessionIds: string[]) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CATCH_SUMMARY, sessionIds],
    queryFn: () => apiGetCatchSummary(sessionIds),
    enabled: sessionIds.length > 0,
  })
}
